import React, { FC, useCallback } from 'react';
import { FORM_FIELDS } from '../../../../../constants';
import { api } from '../../../../../helpers/client';
import { organizationDataToForm } from '../helpers';
import { UseFormReturn } from 'react-hook-form';
import { OrganizationNameField as OrganizationSuggest } from '../../../../../helpers/form.new/fields/work';
import { useDispatch } from 'react-redux';
import { extendFormData } from '../../../../../store/reducers/formStore';

interface OrganizationNameFieldProps {
    form: UseFormReturn;
    onChange?: (event: FE.FieldChangeEvent) => void;
    onBlur?: (event: FE.FieldChangeEvent, onBlur: (...event: any[]) => void, option?: any) => void | Promise<void>;
    onSelect?: (option: Dadata.OrganizationSuggestItem) => void;
    onClear?: () => void;
    onManual?: () => void;
}

export const OrganizationNameField: FC<OrganizationNameFieldProps> = (props) => {
    const { form, onSelect, onManual, onClear, onChange, onBlur, ...other } = props;
    const dispatch = useDispatch();

    const {
        control,
        formState: { errors, dirtyFields: _ },
        setValue,
        clearErrors,
        watch,
    } = form;

    const [kladrId] = watch([FORM_FIELDS.KLADR_ID]);

    const onOrganizationChange: React.ComponentProps<typeof OrganizationSuggest>['onChange'] = useCallback(
        (event, fieldOnChange) => {
            onChange && onChange(event);
            fieldOnChange(event);
        },
        [onChange],
    );

    const onOrganizationSelect = useCallback(
        async (selectedOrganization: Dadata.OrganizationSuggestItem) => {
            const organization =
                (selectedOrganization &&
                    !selectedOrganization.data?.phones &&
                    (await api.organizationByInn(selectedOrganization.data.inn))) ||
                selectedOrganization;

            const dataToUpdate = organizationDataToForm(organization);

            dispatch(extendFormData(dataToUpdate));
            clearErrors(Object.keys(dataToUpdate));
            Object.keys(dataToUpdate).forEach((fieldName) =>
                setValue(fieldName, dataToUpdate[fieldName], { shouldValidate: true }),
            );

            if (onSelect) {
                onSelect(organization);
            }
        },
        [dispatch, onSelect, setValue, clearErrors],
    );

    return (
        <OrganizationSuggest
            control={control}
            error={errors[FORM_FIELDS.ORGANIZATION_NAME]?.message}
            onChange={onOrganizationChange}
            onSelect={onOrganizationSelect}
            onBlur={onBlur}
            onClear={onClear}
            onManual={onManual}
            kladrId={String(kladrId || '')}
            {...other}
        />
    );
};
